<template>
  <div>

    <div v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false" class="buton_salvar"  @click="salvar"><button class="button-salvar"> <i class="fas fa-save"></i> SALVAR</button></div>
      <b-tabs v-model="tabIndex">
           <b-tab :title="'Autorizações'">
            <template slot="title" >
            <span class="d-md-down-none pl-1 text-third">EPI</span>
            </template>
              <HeadDetailsGama :titleHead="'Detalhes do Template'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
              <template #button-edit>
                <div class="d-flex">
                  <div v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false" class="font font-bold  add" @click="abrirPopUpEpi">
                    + ADICIONAR EPI
                  </div>
                  <div class="font font-bold  add" @click="popUptAddClonagem">
                    <i class="fas fa-clone"></i> CLONAR
                  </div>
                </div>
              </template>
              </HeadDetailsGama>

              <tableEpi :aprTemplateReprovado="aprTemplateReprovado" @excluirEpi="excluirEpi" @removerListaDeAlteracoesEPI="removerListaDeAlteracoesEPI"  ref="refEpiByApr" @salvarEpi="salvarEpi" :aprId="aprId" :revisao="revisao" :templateClonado="templateClonado"></tableEpi>
           </b-tab>

           <b-tab :title="'Autorizações'">
            <template slot="title" >
            <span class="d-md-down-none pl-1 text-third"> Ferramentas</span>
            </template>
              <HeadDetailsGama :titleHead="'Detalhes do Template'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
              <template #button-edit>
                <div class="d-flex">
                  <div v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false" class="font font-bold  add" @click="abrirPopUpFerramentas">
                    + ADICIONAR FERRAMENTAS
                  </div>
                  <div class="font font-bold  add" @click="popUptAddClonagem">
                    <i class="fas fa-clone"></i> CLONAR
                  </div>
                </div>
              </template>
              </HeadDetailsGama>
             <tableFerrementas :templateClonado="templateClonado" :aprTemplateReprovado="aprTemplateReprovado" @excluirFerramentas="excluirFerramentas" @removerListaDeAlteracoesFerramentas="removerListaDeAlteracoesFerramentas" @salvarFerramentas="salvarFerramentas" ref="refFerramentasByApr" :aprId="aprId" :revisao="revisao"></tableFerrementas>
           </b-tab>

          <b-tab :title="'Autorizações'">
            <template slot="title" >
            <span class="d-md-down-none pl-1 text-third">Riscos Especiais</span>
            </template>
              <HeadDetailsGama :titleHead="'Detalhes do Template'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
              <template #button-edit>
                <div class="d-flex">
                  <div v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false" class="font font-bold  add" @click="abrirPopUpRiscoEspecial">
                    + ADICIONAR RISCOS ESPECIAIS
                  </div>
                  <div class="font font-bold  add" @click="popUptAddClonagem">
                    <i class="fas fa-clone"></i> CLONAR
                  </div>
                </div>
              </template>
              </HeadDetailsGama>
              <tableRiscoEspecial :templateClonado="templateClonado" :aprTemplateReprovado="aprTemplateReprovado" @salvarRiscoEspecial="salvarRiscoEspecial" @removerListaDeAlteracoesRiscosEspeciais="removerListaDeAlteracoesRiscosEspeciais" @excluirRiscoEspecial="excluirRiscoEspecial" ref="refRiscoEspecialByApr" :aprId="aprId" :revisao="revisao"></tableRiscoEspecial>
           </b-tab>

          <b-tab :title="'Autorizações'">
            <template slot="title" >
            <span class="d-md-down-none pl-1 text-third">Cursos NR</span>
            </template>
              <HeadDetailsGama :titleHead="'Detalhes do Template'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
              <template #button-edit>
                <div class="d-flex">
                  <div v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false" class="font font-bold  add" @click="abrirPopUpCursosNR">
                    + ADICIONAR CURSOS NR
                  </div>
                  <div class="font font-bold  add" @click="popUptAddClonagem">
                    <i class="fas fa-clone"></i> CLONAR
                  </div>
                </div>
              </template>
              </HeadDetailsGama>
              <tableCourseNR :templateClonado="templateClonado" :aprTemplateReprovado="aprTemplateReprovado" ref="refCursosNrByApr" @removerListaDeAlteracoesCursosNR="removerListaDeAlteracoesCursosNR"  @salvarCursosNR="salvarCursosNR" @excluirCursosNR="excluirCursosNR" :aprId="aprId" :revisao="revisao"></tableCourseNR>
           </b-tab>

           <b-tab :title="'Autorizações'">
            <template slot="title">
                <span class="d-md-down-none pl-1 text-third">Template</span>
            </template>
              <HeadDetailsGama :titleHead="'Detalhes do Template'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
              <template #button-edit>
                <div class="d-flex">
                  <div v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false" class="font font-bold  add" @click="abrirPopUpEtapaServico">
                    + ADICIONAR ETAPA DE SERVIÇO
                  </div>
                  <div class="font font-bold  add" @click="popUptAddClonagem">
                    <i class="fas fa-clone"></i> CLONAR
                  </div>
                </div>
              </template>
              </HeadDetailsGama>

              <div class="margim">
                <tableByApr
                 @novosRiscosTemplateVazio="novosRiscosTemplateVazio"
                 @removerListaDeAlteracoesByRiscoId="removerListaDeAlteracoesByRiscoId"
                 @removerListaDeAlteracoesByEtapaServico="removerListaDeAlteracoesByEtapaServico"
                 @removerListaDeInclusaoByEtapaServico="removerListaDeInclusaoByEtapaServico"
                 @removerListaDeAlteracoesCausaByRiscoId="removerListaDeAlteracoesCausaByRiscoId"
                 @riscoExcluir="riscoExcluir"
                 @cancelarriscoExcluir="cancelarriscoExcluir"
                 @causaExcluir="causaExcluir"
                 @cancelaExclusao="cancelaExclusao"
                 @avaliacaoMatrizRisco="avaliacaoMatrizRisco"
                 @salvarRiscoFonteConsequenciaMedida="salvarRiscoFonteConsequenciaMedida"
                 @TemplateAgAprovacao="TemplateAgAprovacao"
                 @TemplateReprovado="TemplateReprovado"
                 @editarRiscoFonteConsequenciaMedidaItens="editarRiscoFonteConsequenciaMedidaItens"
                 ref="refTablaByApr"
                 :aprTemplateReprovado='aprTemplateReprovado'
                 :aprId="aprId"
                 :codigo="codigo"
                 :revisao="revisao"
                 :templateClonado="templateClonado">
                </tableByApr>

              </div>
           </b-tab>

           <b-tab :title="'Autorizações'">
            <template slot="title" >
            <span class="d-md-down-none pl-1 text-third"> Histórico</span>
            </template>
              <HeadDetailsGama :titleHead="'Detalhes do Template'" :buttontemplate="true" v-on:voltarPersonalizado="voltar()" :btnBack="true">
              <template #button-edit>
                <div class="d-flex">
                  <div class="font font-bold  add" @click="popUptAddClonagem">
                    <i class="fas fa-clone"></i> CLONAR
                  </div>
                </div>
              </template>
              </HeadDetailsGama>
              <logApr ref="refAprLog" :aprId="aprId" :templateClonado="templateClonado"></logApr>
           </b-tab>
      </b-tabs>

      <b-modal ref="confimacao-retornar"
        size="md"
        centered
        title=""
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
      >
      <template #modal-title>
        <div class="header-title">Retornar a consulta de Templates</div>
      </template>
        <returnGridTemplate @retonar="confirmacaoVoltar" @cancelaRetorno="cancelarVoltar"></returnGridTemplate>
      </b-modal>

    <b-modal ref="add-novo-template"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
    <template #modal-title>
        <div class="header-title">CLONAR - {{codigo}}</div>
    </template>
    <div v-if="liberaClonar === 1">
      <p class="font-clone">Apenas os itens que foram aprovados serão clonados!</p>

      <i class="fas fa-exclamation icone-alerta"></i>

      <div class="d-flex container_cancel_save">
          <div class="cancelar">
              <button class="button-cancel" @click="cancelarAddTemplate">CANCELAR</button>
          </div>
          <div class="criar">
            <button class="button-save" @click="avancaClonagem">CONTINUAR</button>
          </div>
      </div>
    </div>
    <div v-else>
        <newTemplate
        @cancelarAddTemplate="cancelarAddTemplate"
        @clonagemTemplate="irParaClonagem"
        :clone="aprId"
        :clonagemTabela="clonagemTabela"
        >
        </newTemplate>
    </div>
    </b-modal>
  </div>
</template>

<script>
import tabsApr from './tabsApr'
export default tabsApr
</script>

<style scoped>
.icone-alerta {
  display: flex;
  margin: 1rem 0 1rem 0;
  justify-content: center;
  font-size: 55px;
  color: darkgreen;
}
.font-clone{
  display: flex;
  justify-content: center;
  color: rgb(128, 128, 128);
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 10px;
 }

  .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .add{
    margin-right: 0.6rem;
    cursor: pointer;
  }
  .font-bold {
    font-weight: bold;
  }
  .font {
    font-family: 'Segoe UI';
    font-size: 12px;
    color: #008144;
  }

.margim{
  margin-top: 1rem;
}
.col-md-3{
  padding-right: 0;
  padding-left: 0;
 }
.title-card-sales {
  font-size: 24px;
  background: #008144;
  padding: 20px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  font-weight: bold;
}
.buton_salvar{
  display: flex;
  float: right;
  justify-content: end;
}
.button-salvar{
  font-size: 12px;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 100px;
  height: 30px;
  background-color: #008144;
  color: white;
}
.button-save{
  margin-top: 10;
  font-size: 12px;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 100px;
  height: 30px;
  background-color: #008144;
  color: white;
}
.button-cancel{
  background-color: #b60000;
  margin-top: 10;
  font-size: 12px;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 100px;
  height: 30px;
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/tabsApr/tabsApr.vue